var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.row.startTime.substr(0,16)))]),_c('span',[_vm._v("至")]),_c('span',[_vm._v(_vm._s(_vm.row.endTime.substr(0,16)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }